/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemNote } from '../../models/system-note';

export interface GetActive$Params {
}

export function getActive(http: HttpClient, rootUrl: string, params?: GetActive$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemNote>>> {
  const rb = new RequestBuilder(rootUrl, getActive.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SystemNote>>;
    })
  );
}

getActive.PATH = '/api/system/note/active';
